import { Component, EventEmitter, Output } from '@angular/core';
import { AssistantsIconsConst } from '@local/common';

@Component({
  selector: 'slack-channel-id-info',
  templateUrl: './slack-channel-id-info.component.html',
  styleUrls: ['./slack-channel-id-info.component.scss'],
})
export class SlackChannelIdInfoComponent {
  readonly assistantsIconsConst = AssistantsIconsConst;

  @Output() gotEvent = new EventEmitter();

  closePopup() {
    this.gotEvent.emit();
  }
}
